import React from 'react';
import { Container,Card, CardContent,Box, Typography, Button, Grid } from '@mui/material';
import DinnerBox from "../images/dinnerbox.png";
import SnackBox from "../images/snackbox.png";
import BatterBox from "../images/batterbox.png";
import dinnerbanner from '../images/dinnerbanner.png';  // Adjust path as needed
import { useNavigate } from 'react-router-dom';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { LocalDining, Fastfood, LocalShipping } from "@mui/icons-material";



const Home = () => {


    const steps = [
        {
            icon: <LocalDining fontSize="large" />,
            title: "Choose Your Style",
            description: "Pick from options to support your family needs Healthy Dinner, Easy Breakfast, Comfort Snacks and many more."
        },
        {
            icon: <Fastfood fontSize="large" />,
            title: "Pick Your Meals",
            description: "Select from daily-changing menu with a variety of nutritious meals, including dinner, snacks, breakfast, and drinks"
        },
        {
            icon: <LocalShipping fontSize="large" />,
            title: "Get Your Delivery",
            description: "Your order arrives Next business day at the choosen pick up location between 6pm to 7pm CDT."
        }
    ];

    const navigate = useNavigate();

    const handleNavigate = (pageName, tabIndex) => {
        navigate(`/${pageName}?tab=${tabIndex}`);
    };

    return (
        <Box sx={{
            width: '100%',
            overflowX: 'hidden',
            boxSizing: 'border-box',
            paddingTop: { xs: '64px', md: '80px' }
        }}>
            {/* Hero Section */}
            <Box sx={{
                width: '100%',
                height: { xs: 'auto', md: '200px' },
                backgroundImage: `url(${dinnerbanner})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: { xs: 'center', md: 'flex-start' }, // Align left on desktop
                padding: { xs: '20px', md: '40px' },
                color: '#fff',
                textAlign: 'center',
                paddingTop: { xs: '60px', md: '100px' },
                paddingLeft: { xs: '16px', md: '10%' },  // Extra left padding for desktop view
                paddingRight: { xs: '16px', md: '0' },
            }}>
                {/* Wrapper to limit content width */}
                <Box sx={{
                    width: { xs: '100%', md: '50%' }, // Full width on mobile, 50% on desktop
                    textAlign: { xs: 'center', md: 'left' }, // Left-align text on larger screens
                }}>
                    <Typography variant="h3" color='#383838' sx={{
                        fontWeight: 'bold',
                        marginBottom: 2,
                        width: { xs: '50%', md: '100%' },
                        fontSize: { xs: '1.0rem', sm: '1.0rem', md: '3rem' }, // Reduce font size for smaller screens
                        textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                    }}>
                        Fresh, Healthy Goodness Delivered!
                    </Typography>
                    <Box>
                        <Button variant="contained" color="primary" sx={{
                            borderRadius: '30px',
                            padding: { xs: '6px 14px', md: '10px 20px' },
                            fontSize: { xs: '0.8rem', md: '1rem' },
                            boxShadow: '2px 2px 5px rgba(0,0,0,0.3)'
                        }} onClick={() => handleNavigate('productlist', 0)}>
                            Pre Order Now
                        </Button>
                    </Box>
                </Box>
            </Box>

            <Container maxWidth="md" sx={{ mt: 4 }} >
            <Grid container spacing={2}>

                <Grid item xs={12}>
                <Typography variant="h6" fontWeight="bold" gutterBottom sx={{
                    width: { xs: '100%', md: '100%' },
                    fontSize: { xs: '1.0rem', sm: '1.0rem', md: '2rem' } // Reduce font size for smaller screens
                   }}>
                    Pre-order your favorite food with just a few clicks and enjoy hot, delicious meals at your doorstep.
                </Typography>

                <Typography variant="h4" color="text.secondary">
                    Here's How We Work
                </Typography>
                </Grid>


                {steps.map((step, index) => (
                    <Grid item xs={12} sm={4} key={index}>
                        <Card sx={{ textAlign: "center", p: 2, height: 250, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                        <CardContent>
                                {step.icon}
                                <Typography variant="h6" fontWeight="bold" gutterBottom>
                                    {step.title}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {step.description}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
            </Container>

            {/* Product Highlights */}
            {[{
                title: "Enjoy Home-Style Healthy Curry Boxes at Affordable Prices!",
                price: "$9.99",
                description: "We offer delicious, home-style healthy dinner boxes at reasonable prices — perfect for a convenient and satisfying meal!",
                image: DinnerBox,
                details:"productlist"
            }, {
                title: "Authentic Homemade Indian Snacks / Spices — Sweet, Spicy & Satisfying!",
                price: "$9.99",
                description: "Craving the taste of home? We offer a variety of homemade Indian snacks, including delicious sweets and spicy mixtures, all prepared with authentic flavors and quality ingredients. ",
                image: SnackBox,
                details:"productlist"
            }, {
                title: "Fresh Breakfast Batters Delivered — Easy, Tasty & Affordable!",
                price: "$5.99",
                description: "Start your mornings right with our freshly prepared breakfast batters, available on a convenient plan at a reasonable price!.",
                image: BatterBox,
                details:"productlist"
            }].map((item, index) => (
                <>
                    <Grid item xs={12} sm={6} md={4} sx={{ p: 2 ,display: "flex", justifyContent: "center"}} >  {/* Padding around each Grid item */}
                        <Card
                            sx={{
                                textAlign: "center",
                                p: 3,  // Padding inside the Card
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",  // Soft shadow effect
                                borderRadius: "15px", // Smooth rounded edges
                                backgroundColor: "#f9f9f9", // Light background color
                                maxWidth: { xs: "100%", md: "80%" }
                            }}
                        >
                            <Grid container alignItems="center" spacing={2}>
                                {/* Left Side - Text Content */}
                                <Grid
                                    item xs={12} md={6}
                                    sx={{
                                        textAlign: { xs: "center", md: "right" },
                                        order: { xs: 2, md: 1 },
                                        p: { xs: 1, md: 2 }  // Padding inside the text grid
                                    }}
                                >
                                    <CardContent>
                                        <Typography
                                            variant="h5"
                                            color='#383838'
                                            sx={{
                                                fontWeight: 'bold',
                                                marginBottom: 1,
                                                fontSize: { xs: '1.3rem', md: '1.8rem' }
                                            }}
                                        >
                                            {item.title}
                                        </Typography>
                                        <Typography
                                            variant="h6"
                                            color="#6e838a"
                                            sx={{ marginBottom: 1, fontSize: { xs: '1rem', md: '1.2rem' } }}
                                        >
                                            Starting at {item.price}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            color="#666"
                                            sx={{ marginBottom: 2, fontSize: { xs: '0.9rem', md: '1rem' } }}
                                        >
                                            {item.description}
                                        </Typography>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => handleNavigate('productlist', index)}
                                            sx={{
                                                borderRadius: '20px',
                                                padding: { xs: '6px 12px', md: '8px 16px' },
                                                fontSize: { xs: '0.8rem', md: '1rem' },
                                                '&:hover': {
                                                    backgroundColor: '#1976d2',
                                                    boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
                                                }
                                            }}
                                        >
                                            Pre Order Now
                                        </Button>
                                    </CardContent>
                                </Grid>

                                {/* Right Side - Image */}
                                <Grid
                                    item xs={12} md={6}
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        order: { xs: 1, md: 2 },
                                        p: { xs: 1, md: 2 }  // Padding inside the image grid
                                    }}
                                >
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        style={{
                                            width: "100%",
                                            maxWidth: "250px",  // Smaller max width
                                            height: "250px",  // Maintain aspect ratio
                                            borderRadius: "15px",
                                            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)",  // Slight shadow effect
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid>

                </>
            ))}

            {/* Contact Section */}
            <Box sx={{ backgroundColor: '#383838', color: 'white', padding: '40px', marginTop: '40px' }}>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h6" sx={{ marginBottom: 1 }}>
                            <PhoneIcon sx={{ verticalAlign: 'middle', marginRight: 1 }} /> (972) 292-9277
                        </Typography>
                        <Typography variant="h6" sx={{ marginBottom: 1 }}>
                            <EmailIcon sx={{ verticalAlign: 'middle', marginRight: 1 }} /> nagskitchentx@gmail.com
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h6">
                            <LocationOnIcon sx={{ verticalAlign: 'middle', marginRight: 1 }} /> 800 W Eldorado Pkwy #128, Little Elm, TX 75068
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export default Home;
